import { useSelector } from '@/store'
import { getCustomTagsAction } from '@/store/orderSlice'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

export function useGetCustomTags() {
  const customTags = useSelector((state) => state.order.customTags)
  const dispatch = useDispatch()

  const customTagsMap = useMemo(() => {
    return customTags
      ? customTags.reduce((prev, cur) => {
          prev[cur.tagId] = cur.tagName
          return prev
        }, {})
      : {}
  }, [customTags])

  useEffect(() => {
    if (!customTags) {
      dispatch(getCustomTagsAction())
    }
  }, [customTags, dispatch])

  return {
    customTags: customTags || [],
    customTagsMap,
  }
}
